import { searchContract } from '@exonet/jsonapi-fetcher/lib/search';
import { simpleQueryString, wildcards } from '@exonet/jsonapi-fetcher/lib/search/utilities';

export const searchDomainHandles = (controls, customerId, excludeCompanyHandles) => {
  const fields = [
    'company',
    'initials',
    'last_name',
    'phone_number',
    'address',
    'zip_code',
    'city',
    'email',
    'country',
  ];

  return searchContract('domain_handles')
    .describe(controls)
    .collapse('hash.keyword')
    .query((value) => ({
      bool: {
        should: [...wildcards(fields, value), simpleQueryString(fields, value)],
        must: { term: { customer_number: customerId } },
        minimum_should_match: 1,
        // Only include handles WITHOUT company when excludeCompanyHandles is true.
        ...(excludeCompanyHandles
          ? {
              must_not: [
                {
                  exists: {
                    field: 'company',
                  },
                },
              ],
            }
          : {}),
      },
    }));
};
